import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LandingPageAppResource from './LandingPageAppResource';
import LuLandingPageSectionTypeAppResource from './LuLandingPageSectionTypeAppResource';
import KnowledgeBaseAppResource from "./KnowledgeBaseAppResource";

class LandingPageLearnSectionAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'landing-page-learn-section';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'landings/pages/learns/sections';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'landingPageUuid',
            'landingPageSectionTypeId',
            'isActive',
            'knowledgeBaseUuid',
            'landingPage',
            'type',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            landingPage: LandingPageAppResource,
            type: LuLandingPageSectionTypeAppResource,
            knowledgeBase: KnowledgeBaseAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            landingPage: 'landing_page_uuid',
            type: 'landing_page_section_type_id',
            knowledgeBase: 'knowledge_base_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        let rules = {
            landingPageUuid: {
                type: 'string',
            },
            landingPageSectionTypeId: {
                type: 'integer',
                presence: true,
            },
            isActive: {
                type: 'boolean',
            },
            knowledgeBaseUuid: {
                type: 'string',
                presence: false
            },
        }
        if (this.isActive) {
            rules.knowledgeBaseUuid.presence = {message: "^Please select a knowledge base."};
        }
        return rules;
    }

}

export default LandingPageLearnSectionAppResource;
